module.exports = __webpack_public_path__ + "assets/svg/Icons/32/date-red-b919ce.svg";